import React, { useState } from "react";
import {
  closestCenter,
  defaultDropAnimationSideEffects,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";

import { Item, SortableItem } from "./SortableItem";

const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: "0.4",
      },
    },
  }),
};

const DndKit = ({
  mode,
  data,
  reorderedArray,
  renderItem,
  customWidth = false,
  getObjectMovedInfos = false,
  keyToDisable,
  idAsKey = null,
  dragTopLeft = false,
}) => {
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
    >
      <SortableContext
        items={data}
        strategy={
          mode === "horizontal"
            ? horizontalListSortingStrategy
            : verticalListSortingStrategy
        }
      >
        {data.map((elem, index) => (
          <SortableItem
            key={idAsKey ? elem[idAsKey] : elem.id}
            id={idAsKey ? elem[idAsKey] : elem.id}
            customWidth={customWidth}
            disableDrag={keyToDisable ? elem[keyToDisable] : false}
            dragTopLeft={dragTopLeft}
          >
            {renderItem(elem, index)}
          </SortableItem>
        ))}
      </SortableContext>
      <DragOverlay dropAnimation={dropAnimationConfig}>
        {activeId ? <Item id={activeId} /> : null}
      </DragOverlay>
    </DndContext>
  );

  function handleDragStart(event) {
    const { active } = event;

    setActiveId(active.id);
  }

  function handleDragCancel() {
    setActiveId(null);
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = data.map((i) => i.id).indexOf(active.id);
      const newIndex = data.map((i) => i.id).indexOf(over.id);
      if (getObjectMovedInfos) {
        reorderedArray(
          arrayMove(data, oldIndex, newIndex),
          active.id,
          newIndex
        );
      } else reorderedArray(arrayMove(data, oldIndex, newIndex));
    }

    setActiveId(null);
  }
};

export default DndKit;
